import Swiper from 'swiper';

const GenerateProductsInBlog = () => {

    const blogProductsWrapper = document.getElementsByClassName('single-blog-products-js')[0];
    const allP = document.querySelectorAll('.single-post article.post-single-page .article-body-container .entry-content.wd-entry-content > p');

    if (blogProductsWrapper) {

        const blogProductsItems = document.getElementsByClassName('single-blog-products-item-js');
        const blogBanner = document.getElementsByClassName('single-blog-banner-js')[0];
        const customPIndexes = document.getElementsByClassName('blog-products-custom-numbers-js')[0];
        const blogTextWrapper = document.getElementsByClassName('single-blog-products-text-js')[0];

        function getMiddleOfParagraphs() {
            let arrayOfPIndex = [];
            if (customPIndexes) {
                const customPIndexData = customPIndexes.dataset.customNumber;
        
                if (customPIndexData.includes(',')) {
                    let splitedIndexes = customPIndexData.split(',');
        
                    for (var i = 0; i < splitedIndexes.length; i++) {
                        arrayOfPIndex.push(allP[Number(splitedIndexes[i]) - 1])
                    }
                } else {
                    arrayOfPIndex.push(allP[Number(customPIndexData) - 1])
                }
            } else {
                if (allP) {
                    let numberOfP = allP.length;
                    let finalNumberP = (Math.round(numberOfP) / 2).toFixed(0);
        
                    arrayOfPIndex.push(allP[Number(finalNumberP) - 1]);
                }
            }
        
            // Dodaj ostatni paragraf do listy
            if (allP && allP.length > 0) {
                arrayOfPIndex.push(allP[allP.length - 1]);
            }
        
            return arrayOfPIndex;
        }

        if (blogProductsItems) {

            let getCorrectPosition = getMiddleOfParagraphs();

            if (getCorrectPosition) {

                function generateHtml(index) {
                    // Create main wrapper for products
                    const blogProductsWrapper = document.createElement('div');
                    blogProductsWrapper.classList.add('blog-products');

                    if(blogTextWrapper) {
                        if(blogTextWrapper.dataset.blogProductTitle) {
                            // Create Title for products
                            const blogProductsTitle = document.createElement('h2');
                            blogProductsTitle.classList.add('blog-products-title');
                            blogProductsTitle.innerText = blogTextWrapper.dataset.blogProductTitle;
                            blogProductsWrapper.appendChild(blogProductsTitle);
                        }

                        if(blogTextWrapper.dataset.blogProductDescription) {
                            // Create Title for products
                            const blogProductsDescription = document.createElement('p');
                            blogProductsDescription.classList.add('blog-products-description');
                            blogProductsDescription.innerText = blogTextWrapper.dataset.blogProductDescription;
                            blogProductsWrapper.appendChild(blogProductsDescription);
                        }
                    }

                    if (blogProductsItems.length > 2) {
                        // Slider - if products more then 2
                        const swiperContainer = document.createElement('div');
                        swiperContainer.classList.add('swiper-container', 'swiper-blog-products-js');
                        blogProductsWrapper.appendChild(swiperContainer);

                        const swiperWrapper = document.createElement('div');
                        swiperWrapper.classList.add('swiper-wrapper');
                        swiperContainer.appendChild(swiperWrapper);

                        [...blogProductsItems].forEach((element) => {
                            // Create Swiper slide
                            const swiperSlide = document.createElement('div');
                            swiperSlide.classList.add('swiper-slide');
                            swiperWrapper.appendChild(swiperSlide);

                            // Create item wrapper - link
                            const blogItem = document.createElement('a');
                            blogItem.classList.add('blog-products__item', `blog-product-counter-${index + 1}`);
                            blogItem.href = element.dataset.blogProductLink;
                            swiperSlide.appendChild(blogItem);

                            // Create info wrapper:
                            if(element.dataset.blogProductInfo) {
                                const infoBox = document.createElement('div');
                                infoBox.classList.add('d-none');
                                infoBox.innerText = element.dataset.blogProductInfo;
                                blogItem.appendChild(infoBox);
                            }

                            // Create Image wrapper
                            const blogItemImage = document.createElement('div');
                            blogItemImage.classList.add('blog-products__item-image');
                            blogItem.appendChild(blogItemImage);

                            // Create img tag with src
                            const blogImg = document.createElement('img');
                            blogImg.src = element.dataset.blogProductImage;
                            blogItemImage.appendChild(blogImg);

                            // Create title wrapper
                            const blogTitle = document.createElement('div');
                            blogTitle.classList.add('blog-products__item-title');
                            blogTitle.innerText = element.dataset.blogProductName;
                            blogItem.appendChild(blogTitle);

                            // Create Promo code box
                            if (element.dataset.blogProductPromocode) {
                                const blogPromo = document.createElement('div');
                                blogPromo.classList.add('blog-products__item-promo');
                                blogPromo.innerHTML = 'Z kodem taniej: <strong>' + element.dataset.blogProductPromocode + '</strong>';
                                blogItem.appendChild(blogPromo);
                            }

                            // Create stars wrapper 
                            const blogStars = document.createElement('div');
                            blogStars.classList.add('blog-products__item-stars');
                            blogItem.appendChild(blogStars);

                            // Create rating wrapper
                            const blogRating = document.createElement('span');
                            blogRating.innerText = element.dataset.blogProductRating;
                            blogStars.appendChild(blogRating);

                            // Create price Wrapper
                            const blogPrice = document.createElement('div');
                            blogPrice.classList.add('blog-products__item-price');
                            blogPrice.innerText = element.dataset.blogProductPrice;
                            blogItem.appendChild(blogPrice);

                            // Create Button
                            const blogButton = document.createElement('div');
                            blogButton.classList.add('blog-products__item-btn');
                            blogButton.innerText = 'Dodaj do koszyka';
                            blogItem.appendChild(blogButton);
                        });
                    } else {
                        // Row - if products less then 3
                        const rowWrapper = document.createElement('div');
                        rowWrapper.classList.add('row');

                        blogProductsWrapper.appendChild(rowWrapper);

                        [...blogProductsItems].forEach((element) => {
                            // Create Swiper slide
                            const swiperSlide = document.createElement('div');
                            swiperSlide.classList.add('col-md-6', 'col-12');
                            rowWrapper.appendChild(swiperSlide);

                            // Create item wrapper - link
                            const blogItem = document.createElement('a');
                            blogItem.classList.add('blog-products__item', `blog-product-counter-${index + 1}`);
                            blogItem.href = element.dataset.blogProductLink;
                            swiperSlide.appendChild(blogItem);

                            // Create info wrapper:
                            if(element.dataset.blogProductInfo) {
                                const infoBox = document.createElement('div');
                                infoBox.classList.add('blog-products__item-infobox');
                                infoBox.style.backgroundColor = element.dataset.blogProductInfoBg;
                                infoBox.innerText = element.dataset.blogProductInfo;
                                blogItem.appendChild(infoBox);
                            }

                            // Create Image wrapper
                            const blogItemImage = document.createElement('div');
                            blogItemImage.classList.add('blog-products__item-image');
                            blogItem.appendChild(blogItemImage);

                            // Create img tag with src
                            const blogImg = document.createElement('img');
                            blogImg.src = element.dataset.blogProductImage;
                            blogItemImage.appendChild(blogImg);

                            // Create title wrapper
                            const blogTitle = document.createElement('div');
                            blogTitle.classList.add('blog-products__item-title');
                            blogTitle.innerText = element.dataset.blogProductName;
                            blogItem.appendChild(blogTitle);

                            // Create Promo code box
                            if (element.dataset.blogProductPromocode) {
                                const blogPromo = document.createElement('div');
                                blogPromo.classList.add('blog-products__item-promo');
                                blogPromo.innerHTML = 'Z kodem taniej: <strong>' + element.dataset.blogProductPromocode + '</strong>';
                                blogItem.appendChild(blogPromo);
                            }

                            // Create stars wrapper 
                            const blogStars = document.createElement('div');
                            blogStars.classList.add('blog-products__item-stars');
                            blogItem.appendChild(blogStars);

                            // Create rating wrapper
                            const blogRating = document.createElement('span');
                            blogRating.innerText = element.dataset.blogProductRating;
                            blogStars.appendChild(blogRating);

                            // Create price Wrapper
                            const blogPrice = document.createElement('div');
                            blogPrice.classList.add('blog-products__item-price');
                            blogPrice.innerText = element.dataset.blogProductPrice;
                            blogItem.appendChild(blogPrice);

                            // Create Button
                            const blogButton = document.createElement('div');
                            blogButton.classList.add('blog-products__item-btn');
                            blogButton.innerText = 'Dowiedz się więcej';
                            blogItem.appendChild(blogButton);
                        });
                    }

                    return blogProductsWrapper;

                }

                function generateBannerHtml(index) {
                    const blogBannerWrapper = document.createElement('div');
                    blogBannerWrapper.classList.add('blog-banner');
                    // Create main wrapper for banner
                    if(blogBanner) {
                        if(blogBanner.dataset.blogBannerImage) {

                            const createBannerLink = document.createElement('a');
                            createBannerLink.classList.add('blog-banner__wrapper')
                            createBannerLink.href = blogBanner.dataset.blogBannerUrl;
                            blogBannerWrapper.appendChild(createBannerLink);

                            const createBannerImage = document.createElement('img');
                            createBannerImage.src = blogBanner.dataset.blogBannerImage;
                            createBannerLink.appendChild(createBannerImage);

                            return blogBannerWrapper;
                        } else {
                            return false;
                        }
                    }
                }




                if(getCorrectPosition) {
                    console.log(getCorrectPosition);
                    for (var j = 0; j < getCorrectPosition.length; j++) {
                        if(getCorrectPosition[j]) {
                            let generatedHtmlElement = generateHtml(j);
                            let generatedBannerHtml = generateBannerHtml(j);

                            if(generatedBannerHtml !== false && j == 0) {
                                getCorrectPosition[j].parentNode.insertBefore(generatedBannerHtml, getCorrectPosition[j].nextElementSibling);
                            } else {
                                getCorrectPosition[j].parentNode.insertBefore(generatedHtmlElement, getCorrectPosition[j].nextElementSibling);
                            }
        
                            if (blogProductsItems.length > 2) {
                                const homeSlider = new Swiper('.swiper-blog-products-js', {
                                    speed: 400,
                                    spaceBetween: 15,
                                    slidesPerView: 1,
                                    breakpoints: {
                                        768: {
                                            slidesPerView: 2,
                                            spaceBetween: 20
                                        },
                                    }
                                });
                            }
                        }
                    }
                }

            }
        }

    }

}

export default GenerateProductsInBlog;